import React from "react";
import styled from "styled-components";
import AddAccount from "./components/add-account";
import TableFilters from "./components/table-filters";
import Table from "./components/accounts-table";

const AddAccountWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 32px 16px;
  margin: 0 auto;
  max-width: 1600px;
  @media (max-width: 1200px) {
    flex-direction: column;
  }

  @media (max-width: 900px) {
    padding: 16px 8px;
  }
`;

const AddAccountStyled = styled(AddAccount)`
  flex-shrink: 0;
  @media (max-width: 1200px) {
    margin-bottom: 32px;
    width: 100%;
  }
`;

const TableFilterStyled = styled(TableFilters)`
  margin-left: 32px;
  @media (max-width: 1200px) {
    margin-left: 0px;
    padding-bottom: 116px;
  }
`;

const Dashboard = () => (
  <>
    <AddAccountWrapper>
      <AddAccountStyled />
      <TableFilterStyled />
    </AddAccountWrapper>
    <Table />
  </>
);

export default Dashboard;
